<a class="inline-flex items-center" routerLink="/">
  <img class="md:hidden" [src]="'/logos/logo-compact-dark.svg' | staticImageUrl" alt="RateMyAgent" width="32" height="36" />
  <img class="hidden md:block xl:hidden" [src]="'/logos/logo-stacked.svg' | staticImageUrl" alt="RateMyAgent" width="64" height="36" />
  <img class="hidden xl:block" [src]="'/logos/logo-dark.svg' | staticImageUrl" alt="RateMyAgent" width="120" height="36" />
</a>
